import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { withRoomContext } from "../../../context/RoomContext";
import { useIntl } from "react-intl";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SendIcon from "@material-ui/icons/SendOutlined";
import Attachment from "@material-ui/icons/AttachFileOutlined";
import Download from "@material-ui/icons/GetApp";
import axios from "axios";
import fileSaver from "file-saver";
import moment from "moment";

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    display: "flex",
    borderRadius: 24,
    height: 64,
    border: "solid 1px #f0f3f6",
    margin: theme.spacing(2),
  },
  chatInput: {
    flexGrow: 1,
  },
});

function uuid() {
  const chars = "0123456789abcdef".split("");

  let uuid = [],
    rnd = Math.random,
    r;
  uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
  uuid[14] = "4"; // version 4

  for (let i = 0; i < 36; i++) {
    if (!uuid[i]) {
      r = 0 | (rnd() * 16);

      uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r & 0xf];
    }
  }

  return uuid.join("");
}

function getUrlOrSelf(string) {
  let url = string.match(/href="([^"]*)/);
  if (url) {
    return url[1];
  }
  return string;
}

let uploadRef;
const ChatInput = (props) => {
  const [message, setMessage] = useState("");
  const privateChat = useSelector((state) => state.privateChat);
  const me = useSelector((state) => state.me);

  const intl = useIntl();
  const createNewMessage = (text, sender, name) => ({
    type: "message",
    text,
    name,
    sender,
  });

  const createNewPrivateMessage = (text, sender, name, selectedPeerId) => ({
    type: "message",
    text,
    name,
    selectedPeerId,
    sender,
  });

  const handleChange = (e) => {
    setMessage(e.target.value);
  };
  const {
    roomClient,
    displayName,
    picture,
    canChat,
    chat,
    classes,
    selectedPeerId,
  } = props;

  const handleSendMessage = () => {
    if (message && message.trim() !== "") {
      if (selectedPeerId) {
        const sendPrivateMessage = createNewPrivateMessage(
          message,
          "response",
          displayName,
          selectedPeerId,
          "11111"
        );
        roomClient.sendPrivateChatMessage(sendPrivateMessage);
      } else {
        const sendMessage = createNewMessage(
          message,
          "response",
          displayName,
          "11111"
        );
        roomClient.sendChatMessage(sendMessage);
      }
      setMessage("");
    }
  };

  return (
    <Paper className={classes.root} elevation={0}>
      <IconButton
        aria-label="Send"
        disabled={!canChat}
        onClick={() => {
          uploadRef.click();
        }}
        size="small"
      >
        <Attachment />
      </IconButton>
      <IconButton
        aria-label="Download"
        disabled={!canChat}
        size="small"
        onClick={() => {
          let messages = [];
          if (selectedPeerId) {
            let chatId;
            if (me.id > selectedPeerId) chatId = me.id + selectedPeerId;
            else chatId = selectedPeerId + me.id;
            privateChat.get(chatId).forEach((message) => {
              let row = `${moment(message.time).format(
                "MM.DD.YYYY HH:mm:ss"
              )} | ${message.name} | ${getUrlOrSelf(message.text)}`;
              messages.push(`${row}\n`);
            });
          } else {
            chat.forEach((message) => {
              let row = `${moment(message.time).format(
                "MM.DD.YYYY HH:mm:ss"
              )} | ${message.name} | ${getUrlOrSelf(message.text)}`;
              messages.push(`${row}\n`);
            });
          }
          let blob = new Blob(messages, { type: "text/plain;charset=utf-8" });
          fileSaver.saveAs(blob, "chat.txt");
        }}
      >
        <Download />
      </IconButton>

      <InputBase
        className={classes.chatInput}
        placeholder={intl.formatMessage({
          id: "label.chatInput",
          defaultMessage: "Enter chat message...",
        })}
        value={message || ""}
        style={{ width: "-webkit-fill-available" }}
        disabled={!canChat}
        onChange={handleChange}
        onKeyPress={(ev) => {
          if (ev.key === "Enter") {
            ev.preventDefault();
            handleSendMessage();
          }
        }}
      />

      <input
        id="myInput"
        type="file"
        ref={(ref) => (uploadRef = ref)}
        style={{ display: "none" }}
        onChange={(event) => {
          event.stopPropagation();
          event.preventDefault();
          let file = event.target.files[0];
          if (file) {
            let fileId = uuid();

            let fileName = file.name;
            let fileSize = file.size;
            let mimeType = file.type;

            if (fileSize && fileSize > window.config.fileSizeLimit) {
              roomClient.dispatchNotification(
                "file.sizeLimitExceeded",
                "error",
                "File size limit exceeded"
              );
              return;
            }

            let formData = new FormData();
            formData.append("file", file);
            formData.append("fileId", fileId);
            formData.append("fileName", fileName);
            formData.append("fileSize", fileSize.toString());
            formData.append("mimeType", mimeType);

            axios
              .post(window.config.apiFileServiceUrl, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((res) => {
                if (res.status === 200) {
                  if (selectedPeerId) {
                    let sendPrivateMessage = createNewPrivateMessage(
                      '<a href="' +
                        window.config.apiFileServiceUrl +
                        fileId +
                        '" title="' +
                        fileName +
                        '">' +
                        fileName +
                        "</a>",
                      "response",
                      displayName,
                      selectedPeerId,
                      "11111"
                    );
                    roomClient.sendPrivateChatMessage(sendPrivateMessage);
                  } else {
                    const sendMessage = createNewMessage(
                      '<a href="' +
                        window.config.apiFileServiceUrl +
                        fileId +
                        '" title="' +
                        fileName +
                        '">' +
                        fileName +
                        "</a>",
                      "response",
                      displayName,
                      picture,
                      "11111"
                    );
                    roomClient.sendChatMessage(sendMessage);
                  }
                }
              })
              .catch((error) => {
                if (error.response.status === 481) {
                  roomClient.dispatchNotification(
                    "file.sizeLimitExceeded",
                    "error",
                    "File size limit exceeded"
                  );
                } else if (error.response.status === 482) {
                  roomClient.dispatchNotification(
                    "file.typeNotAllowed",
                    "error",
                    "File type is not allowed"
                  );
                }
              });
          } else
            roomClient.dispatchNotification(
              "file.typeNotAllowed",
              "error",
              "File type is not allowed"
            );
        }}
      />

      <IconButton
        color="inherit"
        aria-label="Send"
        disabled={!canChat}
        onClick={handleSendMessage}
      >
        <SendIcon />
      </IconButton>
    </Paper>
  );
};

ChatInput.propTypes = {
  roomClient: PropTypes.object.isRequired,
  displayName: PropTypes.string,
  picture: PropTypes.string,
  canChat: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  chat: PropTypes.array,
  selectedPeerId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  displayName: state.settings.displayName,
  picture: state.me.picture,
  chat: state.chat,
  canChat: state.me.roles.some((role) =>
    state.room.permissionsFromRoles.SEND_CHAT.includes(role)
  ),
});

export default withRoomContext(
  connect(mapStateToProps, null, null, {
    areStatesEqual: (next, prev) => {
      return (
        prev.room.permissionsFromRoles === next.room.permissionsFromRoles &&
        prev.me.roles === next.me.roles &&
        prev.settings.displayName === next.settings.displayName &&
        prev.me.picture === next.me.picture &&
        prev.chat === next.chat &&
        prev.selectedPeerId === next.selectedPeerId
      );
    },
  })(withStyles(styles)(ChatInput))
);
